/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlansCountForCategoryQueryResult } from '../../models/get-plans-count-for-category-query-result';

export interface ApiPlanGetPlansCountForCategoryGet$Plain$Params {
  CategoryId?: string;
  IsProject?: boolean;
  Date?: string;
  StackholderId?: number;
}

export function apiPlanGetPlansCountForCategoryGet$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanGetPlansCountForCategoryGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansCountForCategoryQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanGetPlansCountForCategoryGet$Plain.PATH, 'get');
  if (params) {
    rb.query('CategoryId', params.CategoryId, {});
    rb.query('IsProject', params.IsProject, {});
    rb.query('Date', params.Date, {});
    rb.query('StackholderId', params.StackholderId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlansCountForCategoryQueryResult>;
    })
  );
}

apiPlanGetPlansCountForCategoryGet$Plain.PATH = '/api/Plan/GetPlansCountForCategory';
